import { render, staticRenderFns } from "./MemberDuplicateList.vue?vue&type=template&id=8c34d6d4"
import script from "./MemberDuplicateList.vue?vue&type=script&lang=js"
export * from "./MemberDuplicateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports